import { createSignal, onCleanup } from "solid-js";

const [mounted, setMounted] = createSignal(0);

/**
 * Konkord: whether the call controls panel is on screen (the channel sidebar
 * can be collapsed, or the page has none), so the mini call window can stand in
 */
export const statusPanelShown = () => mounted() > 0;

/**
 * Konkord: register a mounted call controls panel for the owner's lifetime
 */
export function useStatusPanelPresence() {
  setMounted((count) => count + 1);
  onCleanup(() => setMounted((count) => count - 1));
}
